import { PropsWithChildren, useContext } from 'react';
import { appContext } from '../../../../Contexts/AppContext';
import Loading from '../../../Loading';
import { DrillholeContext } from '../../../../Contexts/DrillholeContext';

export const VisualizerV3GlobalDataValidator = ({
  children,
}: PropsWithChildren) => {
  const { activeProject, company, db } = useContext(appContext);
  const { drillholesMapReady } = useContext(DrillholeContext);

  if (
    company == null ||
    activeProject == null ||
    !db?.isOpen() ||
    !drillholesMapReady
  ) {
    return <Loading />;
  }

  return children;
};
